import { createFileRoute } from '@tanstack/react-router'
import { BookAppointmentPage } from '@/pages/book-appointment'

export const Route = createFileRoute('/_authenticated/book-appointment')({
  component: BookAppointmentPage,
})